<template>

    <popup v-show="show" @closePopup="closePopup">

        <div class="foxy-glasses-container">

            <img class="img-foxy-glasses" src="/img/foxy/glasses.svg" alt="foxy's glasses">

        </div>

        <div class="pu-welcome">

            <h1 class="pu-title">{{ $t('tuto_welcome_1_title') }}</h1>

            <span class="pu-text">{{ $t('tuto_welcome_1_text_1') }}</span>
            <span class="pu-text">{{ $t('tuto_welcome_1_text_2') }}</span>

            <div class="pu-btn-container">

                <button class="btn btn-pu" @click="closePopup">{{ $t('global_cta') }}</button>

            </div>

        </div>

    </popup>

</template>

<script>

import Popup from '@/components/popup/Popup'
import Tag from '@/modules/tag'

export default {

    name: 'popup-tuto-welcome',

    components: { Popup },

    data () {
        return {
            show: false
        }
    },

    methods: {

        open () {

            this.show = true
            Tag.popupAmplitude(this, 'tuto_1')
        },

        closePopup () {

            Tag.clickAmplitude(this, 'tuto_1_ok')
            Tag.clickGA(this, 'tuto_3_1_next')
            this.$emit('close')
            this.show = false
        }

    }

}

</script>

<style scoped lang="scss">

    .pu-welcome {
        padding: 34px 16px 8px;
        display: flex;
        flex-direction: column;
    }

    .pu-title {
        font-size: 16px;
        font-weight: bold;
        min-height: 20px;
        margin-bottom: 5px;
    }

    .pu-text {
        font-size: 14px;
        line-height: 1.43;
        text-align: center;
    }

    .pu-btn-container {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .btn-pu {
        width: min-content;
        height: 40px;
        font-size: 14px;
        font-weight: bold;
        color: $aquamarine;
        margin-top: 8px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 16px;
    }

    .foxy-glasses-container {
        position: absolute;
        top: -32px;
        background-color: $midnight;
        border-radius: 100px;
    }

    .img-foxy-glasses {
        width: 64px;
        object-fit: contain;
    }


</style>
